import { Component, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { OrderState } from "../../enums/order-state.enum";
import { RolesEnum } from "../../enums/roles.enum";
import { AuthService } from "../../services/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { Quotation } from "../../models/quotation.model";
import { QuotationState } from "../../enums/quotation-state.enum";
import { Router } from "@angular/router";
import { OrderService } from "../../services/order.service";
import { OrganizationService } from "../../services/organization.service";

@Component({
  selector: 'app-quotation-information',
  templateUrl: './quotation-information.component.html',
  styleUrls: ['./quotation-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class QuotationInformationComponent implements OnInit {
  @Input() quotation: Quotation;
  public dialogData = inject(MAT_DIALOG_DATA, { optional: true });
  public dialogRef = inject(MatDialogRef<QuotationInformationComponent>, { optional: true });
  
  protected readonly OrderState = OrderState;
  protected readonly RolesEnum = RolesEnum;
  protected readonly QuotationState = QuotationState;

  authService = inject(AuthService);
  translate = inject(TranslateService);

  private orderService = inject(OrderService);
  private organizationService = inject(OrganizationService);
  private router = inject(Router);

  ngOnInit(): void {
    if (this.dialogData && this.dialogData.quotation) {
      this.quotation = this.dialogData.quotation;
    }
  }

  /**
   * Get a list of quotation contacts
   * @returns The list of contact slitted with comma
   */
  getContacts(): string {
    if (!this.quotation || !this.quotation.contacts || !this.quotation.contacts.length) {
      return '--';
    }
    return this.quotation.contacts.join(', ');
  }

  /**
   * Navigates to the order page associated with the current quotation's transaction ID.
   * This method fetches the order details using the provided transaction ID
   * and redirects the user to the corresponding order page.
   * @returns A promise that resolves when the navigation is complete.
   */
  async goToOrder(): Promise<void> {
    const order = await this.orderService.getOrderByTransactionId(this.quotation.transactionId);
    await this.router.navigate(['/', this.organizationService.currentOrganization.oid, 'order', order.id]);
  }
}
